<template>
    <div class="center-map">
        <div class="top-head">
            <img src="../../assets/imgs/center/bg-principle.jpg" style="width: 100%;">
        </div>
        <div class="section-content" style="padding: 70px 0px;" >

            <div v-for="(item,i) in arr" :key="i" :class="{city:true,grad: i==indexTab,gray:i!=indexTab}" @click="ajaxFn(i,item.CityCode)">{{item.CityName}}</div>
            <div class="address">
                  <div class="group" v-for="(list,i) in centerArr" :key="i">
                      <div style="font-size: 28px;line-height: 32px;"><img src="../../assets/imgs/center/zhongxin.png"/>{{list.OrgName}}</div>
                      <p>{{list.Addr}}</p>
                      <div style="font-size: 24px;margin-top:4px;margin-top:-2px;"><img src="../../assets/imgs/center/phone.png" />{{list.Phone}}</div>
                  </div>
            </div>

            <div>
                <el-carousel v-show="centerArr" :interval="5000" height="400px" indicator-position="none" arrow="always" style="z-index: 0;">
                    <!--<el-carousel-item  v-for="(list,i) in centerArr" :key="i">-->
                     <!--<img  :src="list.Images"/>-->
                    <!--</el-carousel-item>-->
                    <el-carousel-item v-if="images"  v-for="(list,i) in images" :key="i">
                        <img  :src="list"/>
                    </el-carousel-item>
                </el-carousel>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data(){
            return{
                indexTab: 0,
                city: '',
                arr:[],
                centerArr:[],
                images:''
            }
        },
        watch: {
            $route(){
                if(this.$route.query.city){
                    this.cityFn()
                }
            }
        },
        created() {
            if(this.$route.query.province){
                this.arr.push({CityName:this.$route.query.name});
                this.ajaxFn(0,this.$route.query.province);
            }else{
                this.cityFn();
            }
        },
        methods:{
            ajaxFn(i=0,name){
                this.indexTab = i;
                this.city = name;
                this.$http.get('https://q.qitianzhen.cn/api/center_list',{params:{city: this.city }}).then(res=>{
                    this.centerArr=res.body.list;
                    this.images = res.body.images;
                })
            },
            cityFn(){
                this.$http.get('https://q.qitianzhen.cn/api/city_list',{params:{province: this.$route.query.city }}).then(res=>{
                    this.arr = res.body.list;
                    this.ajaxFn(0,this.arr[0].CityCode)
                })
            }

        }
    }
</script>
<style scoped lang="less">
    .center-map{
        //  .top-head{
        //      /*height: 638px;*/
        //      /*background: url('../../assets/imgs/center/bg-principle.png') 100% 100% no-repeat;*/
        //  }

        .city{
            display: inline-block;
            width: 160px;
            height: 45px;
            line-height: 45px;
            text-align: center;
            margin-right: 10px;
            margin-bottom: 16px;
            cursor: pointer;
            font-size: 24px;
            font-family: Light;
            &:hover{
                color: #ffffff;

                background: -webkit-linear-gradient(left top, #fbad27, #fec006); /* Safari 5.1 - 6.0 */
                background: -o-linear-gradient(bottom right, #fbad27, #fec006); /* Opera 11.1 - 12.0 */
                background: -moz-linear-gradient(bottom right, #fbad27, #fec006); /* Firefox 3.6 - 15 */
                background: linear-gradient(to bottom right, #fbad27, #fec006); /* 标准的语法 */
            }

        }
        .gray{
            background: #eeeeee;
            color: #b9b9b9;
        }
        .grad {
            color: #ffffff;
            /*font-weight: 600;*/
            background: -webkit-linear-gradient(left top, #fbad27, #fec006); /* Safari 5.1 - 6.0 */
            background: -o-linear-gradient(bottom right, #fbad27, #fec006); /* Opera 11.1 - 12.0 */
            background: -moz-linear-gradient(bottom right, #fbad27, #fec006); /* Firefox 3.6 - 15 */
            background: linear-gradient(to bottom right, #fbad27, #fec006); /* 标准的语法 */
        }
        .address{
            width: 1000px;
            margin: 50px auto;
            color: #3c3c3c;
            font-weight: 600;
            font-size: 24px;
             .group{
                 width: 450px;
                 vertical-align: top;
                 margin-right: 100px;
                 border-bottom: 1px dashed #eeeeee;
                 margin-bottom: 50px;
                 padding-bottom: 40px;
                 display: inline-block;
                 &:nth-child(2n+2){
                     margin-right: 0px;
                 }
                p{
                    font-size: 17px;
                    font-weight: normal;
                    margin: 15px 0px 8px;
                    position: relative;
                    padding-left: 40px;
                    &:after{
                        content: '';
                        width: 32px;
                        height: 32px;
                        position: absolute;
                        top: -2px; 
                        left: 0px;
                        background: url("../../assets/imgs/center/map.png") 100% 100% no-repeat;
                   }
                }
                
                img{vertical-align: top; margin-right: 8px;}
             }

        }





        .el-carousel__container{


                img {
                    height: 400px;
                    margin-left: 50%;
                    transform: translateX(-50%);
                }

        }
        .el-carousel__item{
            background: #fdfbfc;
        }
        /*.el-carousel__item:nth-child(2n) {*/
        /*    background-color: #99a9bf;*/
        /*}*/

        /*.el-carousel__item:nth-child(2n+1) {*/
        /*    background-color: #d3dce6;*/
        /*}*/
    }
</style>
